export default __webpack_public_path__ + "static/media/minus.de4b2da5.svg";